import gql from 'graphql-tag';

export const ClientsSearch = gql`
	query clientSearch($brokerId: String!, $search: String!, $token: String!) {
		ClientsSearch(brokerId: $brokerId, search: $search, token: $token) {
			id
			scd_name
			scd_surname
			full_name
			scd_email
		}
	}
`;

export const ClientProfileSummary = gql`
	query clientProfileSummary($id: String!, $token: String!) {
		ClientProfileSummary(id: $id, token: $token) {
			id
			scd_pp_path
			scd_name
			scd_surname
			scd_initials
			scd_email
			scd_cellNumber
			scd_title
			invite_sent
			app_active
			scd_clientType
			scd_dateOfBirth
			scd_monthlyIncome
			scd_smoker
			scd_maritalStatus
			scd_qualification
			scd_selfEmployed
			scd_salaryType
			scd_taxDispensation
			scd_spouseIncome
			scd_pAdmin
			scd_pTravel
			scd_pManual
			scd_pSupervision
			scd_gender
			scd_occupation
		}
	}
`;

export const ClientAdvSearch = gql`
	query clientAdvSearch(
		$brokerId: String!
		$token: String!
		$occupation: String
		$title: String
		$language: String
		$smoker: String
		$birthdayFrom: String
		$birthdayTo: String
		$anneversaryFrom: String
		$anneversaryTo: String
		$incomeFrom: String
		$incomeTo: String
		$ageFrom: String
		$ageTo: String
	) {
		ClientAdvSearch(
			brokerId: $brokerId
			token: $token
			occupation: $occupation
			title: $title
			language: $language
			smoker: $smoker
			birthdayFrom: $birthdayFrom
			birthdayTo: $birthdayTo
			anneversaryFrom: $anneversaryFrom
			anneversaryTo: $anneversaryTo
			incomeFrom: $incomeFrom
			incomeTo: $incomeTo
			ageFrom: $ageFrom
			ageTo: $ageTo
		) {
			id
			scd_name
			scd_surname
			scd_nickName
			scd_secondAndOtherNames
			scd_maidenName
			scd_initials
			full_name
			scd_email
			scd_title
			scd_gender
			scd_saID
			scd_smoker
			scd_correspondenceLanguage
			scd_correspondenceType
			scd_cellNumber
			scd_phoneNumber
			date_of_birth
			age
			scd_monthlyIncome
			scd_weddingDate
			scd_maritalStatus
			scd_clientFileNumber
			scd_residentialAddress
			scd_residentialAddress2
			scd_residentialAddress3
			scd_residentialAddress4
			scd_postalCode
			scd_postalAddress1
			scd_postalAddress2
			scd_postalAddress3
			scd_postalAddress4
			scd_postalAddressCode
			sb_accountName
			sb_bank
			sb_branchName
			sb_branch
			sb_accountType
			date_created
			date_modified
		}
	}
`;



// WEBPACK FOOTER //
// ./src/queries/clients/queries.js